import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setToken } from "@/lib/api";

/**
 * Impersonation entry: /impersonate?token=XXX&redirect=/reseller
 * Saves the token in SESSION storage (tab-scoped), then redirects.
 * The master's original tab keeps its localStorage token intact.
 */
export default function Impersonate() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    const redirect = params.get("redirect") || "/";
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    setToken(token, { session: true });
    // Full reload so AuthContext re-inits with the new token
    window.location.replace(redirect);
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-[#5C5C59]">
      Abrindo painel…
    </div>
  );
}
